import React, { useState } from "react";
import './home.css';
import axios from "axios";
import {Button} from "../button/Button";
import Perc from "./Perc";

const mainurl = process.env.REACT_APP_MURL || "http://localhost:1729";
const url = `${mainurl}/love`

const Home = ({sd}) => {

  const [name1, setName1] = useState("");
  const [name2, setName2] = useState("");
  const [gname1, setGname1] = useState("");
  const [gname2, setGname2] = useState("");
  const [percentage, setPercentage] = useState(null);
  const [result, setResult] = useState();
  const [nch, setNch] = useState(false);
  // const [error, setError] = useState("");

  const flames = (name1, name2) => {
    if (!name1 || !name2) return;

    const flamesLetters = ['F', 'L', 'A', 'M', 'E', 'S'];
    let lname1 = name1.trim().toLowerCase();
    let lname2 = name2.trim().toLowerCase();

    for (let i = 0; i < lname1.length; i++) {
      let char = lname1[i];
      if (lname2.includes(char)) {
        lname1 = lname1.replace(char, '');
        lname2 = lname2.replace(char, '');
      }
    }
    let combined = lname1 + lname2;
    let clen = combined.length;

    let index = 0;
    let flamesCopy = [...flamesLetters];
    while (flamesCopy.length > 1) {
      index = (index + clen - 1) % flamesCopy.length;
      flamesCopy.splice(index, 1);
    }

    
    const ctime = new Date().toLocaleString('en-GB', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });

    const flameResult = flamesCopy[0];
    setResult(fnd(flameResult));
    const per = calculateLovePercentage(name1, name2);
    setPercentage(per);
    setGname1(name1);
    setGname2(name2);
    if (sd === "s") {
      sentoDB({ name1, name2, result: fnd(flameResult), percentage: per,ctime:ctime });
    }
    setName1("");
    setName2("");
  };

  const sentoDB = async (ress) => {
    try {
      const response = await axios.post(url, ress);
      console.log({ ress });
      console.log("bData :", response.data);
    } catch (error) {
      console.error("Error in bData:", error);
    }
  };



  function fnd(nme) {
    switch (nme) {
      case "F":
        return "Friends";
      case "L":
        return "Lovers";
      case "A":
        return "Affection";
      case "M":
        return "Marriage";
      case "E":
        return "Enemies";
      case "S":
        return "Soulmates";
      default:
        return "";
    }
  }

  function calculateLovePercentage(name1, name2) {
    let combinedString = (name1 + name2).toLowerCase();
    let totalValue = 0;

    for (let i = 0; i < combinedString.length; i++) {
      totalValue += combinedString.charCodeAt(i);
    }

    let percentage = (totalValue % 101);
    return percentage;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    flames(name1, name2);
    setNch(true);
  };

  const getRelationshipMeaning = () => {
    switch (result) {
      case "Friends":
        return (<><strong>{gname1}</strong> and <strong>{gname2}</strong> are buddies. They share trust, fun, and understanding.</>);
      case "Lovers":
        return (<><strong>{gname1}</strong> and <strong>{gname2}</strong> are in love. They feel a deep connection.</>);
      case "Affection":
        return (<><strong>{gname1}</strong> and <strong>{gname2}</strong> care for each other. They share kind moments.</>);
      case "Marriage":
        return (<><strong>{gname1}</strong> and <strong>{gname2}</strong> are married together. They share a life of love.</>);
      case "Enemies":
        return (<><strong>{gname1}</strong> and <strong>{gname2}</strong> are opponents. They may fight but learn from it.</>);
      case "Soulmates":
        return (<><strong>{gname1}</strong> and <strong>{gname2}</strong> are soulmates. Their bond lasts forever.</>);
      default:
        return "";
    }
  };


  return (
    <div className="container">
      <h2 className="header">💙Relationship Calculator💕</h2>
      <form className="form" onSubmit={handleSubmit}>
        <input
          type="text"
          className="input-field"
          placeholder="Your Name"
          value={name1}
          onChange={(e) => { setName1(e.target.value); setNch(false); setResult(null); }}
          pattern="[a-zA-Z\s]*"
          required
          autoFocus
        />
        <input
          type="text"
          className="input-field"
          placeholder="Other's Name"
          value={name2}
          onChange={(e) => { setName2(e.target.value); setNch(false); setResult(null); }}
          pattern="[a-zA-Z\s]*"
          required
        />
        <br />
        <Button label="Calculate" type="submit" />
      </form>
      {result && percentage !== null && (
        <Perc percentage={percentage} nch={nch} />
      )}
      {result && (
        <div className="result">
          <p>Relationship Status: <strong>{result}</strong></p>
        </div>
      )}
      {result && (
        <div className="result">
          <p>{getRelationshipMeaning()}</p>
        </div>
      )}
    </div>
  );
};

export default Home;
